export const API_REFERENCE = {
  module: {
    urlname: 'url'
  },
  checkoutAccount: {
    getProfile: '/checkout/multi/account-information/getProfile',
    createUser: '/checkout/multi/account-information/createuser',
    termsAndConditions:
      '/checkout/multi/account-information/termsandconditions',
    accountInformation: '/checkout/multi/account-information',
    removeContact:
      '/checkout/multi/account-information/removeContact?phoneContactId=',
    registration: '/checkout/multi/account-information/newcustomer',
    newRegistrationRedirect: '/register'
  },
  insurance: {
    showHealthInsurances: '/my-account-home/showHealthInsurances'
  },
  accountSettings: {
    addPhysician: '/provider/addProvider',
    removePhoneContact: '/my-account-home/removeContact',
    updateAccountSettings: '/my-account-home/updateAccountSettings',
    updateOktaUserCredentials: '/my-account-home/updateOktaUserCredentials'
  },
  checkoutInsurance: {
    updateInsuranceInformation:
      '/checkout/multi/insurance/updateHealthInsurance',
    continueToNextStep: '/checkout/multi/insurance/continue',
    retrieveInsurance: '/checkout/multi/insurance/retrieveInsurance',
    updatePromoteInsurance: '/checkout/multi/insurance/resolvePromoteInsurance',
    addHealthInsurance: '/checkout/multi/insurance/addHealthInsurance',
    viewHealthInsurance: '/checkout/multi/insurance/viewHealthInsurances',
    insurancePageReload: '/checkout/multi/insurance'
  },
  checkoutPhysician: {
    viewPhysicians: '/checkout/multi/physician/viewPhysicians',
    saveSearchPhysician: '/checkout/multi/physician/saveSearchPhysician',
    createPhysician: '/checkout/multi/physician/createPhysician'
  },
  checkoutAddress: {
    saveValidatedAddress: '/checkout/multi/delivery-address/saveAddress',
    viewAddress: '/checkout/multi/delivery-address/viewAddresses'
  },
  checkoutDiagnosis: {
    getDiagnosisSurveyForm: '/checkout/multi/diagnosis/add',
    navigateHealthCondition: '/checkout/multi/diagnosis/view'
  },
  accountAddProvider: {
    addNewProvider: '/provider/addNewProvider'
  },
  checkoutAlerts: {
    showAlerts: '/my-account-home/ajaxView',
    getAlertsOnLoad: '/my-account-home/getAlerts',
    validate: '/my-account-home/validate',
    notify: '/modify-order/notify-customer/'
  },
  cart: {
    cancelOrder: '/cart/cancelOrder',
    saveSupplyDetails: '/cart/saveSupplyDetails',
    removeItemFromStickyCart: '/checkout/multi/remove/',
    cartBillingOptionUpdate: '/cart/billingOptionUpdate'
  },
  checkoutActionItem: {
    viewActionItem: '/checkout/multi/action-items/getActionItem'
  },
  checkoutActionItems: {
    removeItem: '/checkout/multi/action-items/remove',
    calculateNextEligibleShipDate:
      '/checkout/multi/action-items/calculateNextEligibleShipDate',
    resolveSupplyOnHand: '/checkout/multi/action-items/resolve',
    getOverrideReasons: '/checkout/multi/action-items/overrideReasons'
  },
  checkoutPaymentMethods: {
    viewPaymentMethod: '/checkout/multi/payment-method/add',
    getWallet: '/checkout/multi/payment-method/wallet',
    addToWallet: '/checkout/multi/payment-method/gettoken',
    reviewOrder: '/checkout/multi/payment-method/choose',
    termsAndConditions: '/checkout/termsAndConditions',
    getOrderTotalAndPaymentOpt:
      '/checkout/multi/payment-method/getOrderTotalAndPaymentOpt',
    getCardData: '/checkout/multi/payment-method/chase-stub-response',
    removeCreditCard: '/checkout/multi/payment-method/remove'
  },
  orderHistory: {
    cancelOrderItem: '/cancel-order/cancel/'
  },
  checkoutShippingMethod: {
    navigateToShippingMethod: '/checkout/multi/delivery-method/choose'
  },
  communicationsPreferences: {
    communicationsPreferencesUpdate: '/my-account-home/saveCommPref'
  },
  modifyOrder: {
    navigateToModifyOrder: '/modify-order/order/',
    navigateToConfirmOrder: '/modify-order/confirmOrder/',
    saveInfantDob: '/modify-order/save-infant-birth-date'
  },
  reorderReminder: {
    smsEnrollSave: '/my-account-home/saveSMSPhoneInfo?action=save',
    smsEnrollUnsubscribe:
      '/my-account-home/saveSMSPhoneInfo?action=unsubscribe',
    chooseAlternateProduct: '/my-account-home/reorder-reminder/alternate/show',
    addToCart: '/my-account-home/reorder-reminder/addProductToCart',
    removeItem: '/my-account-home/reorder-reminder/items/remove'
  },
  resetPwd: {
    resendEmail: '/login/pw/resendEmail'
  },
  mfa: {
    sendCode: '/mfa/sendOTPCode',
    verifyCode: '/mfa/verifyOTPCode',
    getMfaType: '/mfa/mfaFactors',
    getMfaChallenge: '/mfa/factorChallenge',
    verifyFactor: '/mfa/verifyFactor',
    removeFactor: '/mfa/deleteFactor',
    addFactor: '/mfa/addFactor',
    activateFactor: '/mfa/activateFactor',
    resendCode: '/mfa/resendCode'
  },
  resetPassword: {
    submitEmailIdToFactor: '/login/pw/pwdrequest/password_reset',
    verifyOtpCode: '/login/pw/verifyOTPCode',
    emailConfirmationPage: '/login/pw/pwdrequest/pwdrequestConfirmation',
    newPasswordPage: '/login/pw/pwdrequest/pwdSubmitSecurityAnswer',
    submitNewPwd: '/login/pw/pwdchange/password_reset',
    legacyUserCheck: '/login/pw/is-legacy-customer'
  },
  accountDoctor: {
    viewDoctor: '/my-account-home/viewDoctorsDetails',
    searchDoctor: '/provider/submitSearchProvider',
    removeDoctor: '/provider/removeProvider',
    saveProviderAdditionalInfo: '/provider/saveProvider',
    getCityStateNewPhysician: '/viewAddressbook/validateCustomerAddress'
  },
  accountInsurance: {
    searchInsurance: '/my-account-home/searchHealthInsurance',
    removeHealthInsurance: '/my-account-home/removeHealthInsurance',
    showAddInsurance: '/my-account-home/showAddInsurance',
    saveAdjustedInsurancePlan:
      '/my-account-home/saveAdjustedHealthInsurancePlan'
  },
  accountAddressBook: {
    removeAddress: '/viewAddressbook/removeAddress',
    removeReplaceAddress: '/viewAddressbook/removeReplaceAddress',
    updateDefaultAddress: '/viewAddressbook/updateToNewDefaultAddress',
    updateAddress: '/viewAddressbook/updateAddress',
    addNewAddress: '/viewAddressbook/addAddress'
  },
  accountDiagnosis: {
    diagnosisQuestions: '/diagnosis-survey/getQuestions',
    viewConditions: '/my-account-home/viewConditions',
    saveSurveyAnswers: '/diagnosis-survey/saveSurveyAnswers',
    deleteDiagnosis: '/diagnosis-survey/deleteDiagnosis'
  },
  miniCart: {
    updateMinicartQuantity: '/cart/miniCart/'
  },
  facilitySearch: {
    referralSearchFacility: '/referral/search-facility',
    selectedFacility: '/referral/selected-facility',
    editFacility: '/referral/edit-facility',
    saveNewFacility: '/referral/add-facility'
  },
  newRegistration: {
    newCustomerRegistration: '/register/newcustomer',
    existingCustomerRegistration: '/register/existingcustomer',
    existingCustomerRegistrationStep2: '/register/existingcustomer/security',
    finalCreateUser: '/register/createuser',
    navigateToMarketingConsent: '/register/marketingconsent',
    openTermsAndConditions: '/register/termsandconditions',
    edgeparkUrl: 'https://my.edgepark.com/'
  },
  accountAuthorizedContacts: {
    saveAuthorizedContacts: '/my-account-home/saveAuthorizedContacts',
    removeAuthorizedContact: '/my-account-home/removeAuthorizedContact'
  },
  insuranceVerificationChecker: {
    getInsuranceProviders: '/insuranceVerification/coverage/'
  },
  preregister: {
    validatePreregistrationStep1: '/preregister'
  },
  returns: {
    returnsPagination: '/my-account-home/returns'
  },
  patientMarketFlow: {
    marketingConsentUrl: '/register/marketingconsent',
    patientConsentUrl: '/register/patientconsent',
    termsAndConditionUrl: '/register/termsandconditions'
  },
  orderConfirmation: {
    getOrderProcessingDocumentsUrl: '/checkout/getOrderProcessingDocuments/',
    removeCartFromSession: '/checkout/removeCartFromSession'
  },
  sessionTimeout: {
    logout: '/logout?logoutPopup=true',
    defaultLogout: '/logout',
    locationURL: '/lastVisitedPage'
  },
  babyAcademy:{
    optInOrOut: '/my-account-home/baby-academy-opt-in-out'
    }
};
